module.exports = __webpack_public_path__ + "static/media/MenuDashboard.d1ab10e7.svg";